import { Action } from 'state/actions';
import { BaseMetadata, FormMetadataByWorkspace, FormMetadataStateMap } from 'state/forms/metadata/model';
import { HandledWorkspace } from 'state/forms/models';
import { addOrReplaceKey, removeKey } from 'state/utils/collection';
import { Collection } from 'state/utils/types';

function formByWorkspace<T extends HandledWorkspace>(state: FormMetadataStateMap, _action: Action & { workspace: T }) {
  return state as Collection<FormMetadataByWorkspace<T>>;
}
export function metadataReducer(state: FormMetadataStateMap = {}, action: Action): FormMetadataStateMap {
  switch (action.type) {
    case 'WORKSPACE_RESET_TAB_REQUESTED':
      return removeKey(state, action.tabId);
    case 'WORKSPACE_TAB_REMOVED':
      return removeKey(state, action.id);
    case 'DEFAULT_FORM_RECEIVED':
    case 'FORM_ENRICHMENT_RECEIVED':
    case 'FORM_RELOADED':
      const newState: BaseMetadata = { blocks: action.blocksMetadata, fields: action.fieldsMetadata };
      if (action.workspace === 'dynamic') {
        return addOrReplaceKey(formByWorkspace(state, action), action.tabId, {
          ...newState,
          productGraph: action.productGraph,
          workspace: action.workspace,
        });
      }
      return addOrReplaceKey(formByWorkspace(state, action), action.tabId, {
        ...newState,
        workspace: action.workspace,
      });

    default:
      return state;
  }
}
